export const CDN_BASE = 'https://widget.bland.ai'

export const DEFAULT_CONFIG = {
  styles: {
    widget: {
      width: 47,
      height: 47,
      bottom: 20,
      right: 20,
    },
    headerLogo: {
      height: 28,
      width: 28,
    },
    logo: {
      width: 35,
      height: 35,
      padding: 7,
    },
    panel: {
      width: 380,
      height: 600,
      bottom: 80,
      right: 20,
    },
  },
  primaryColor: '#000000',
  secondaryColor: '#000000',
  hideFooter: false,
  headerContent: 'Chat Support',
  widgetIcon: '',
  threads: [
    {
      messages: [
        {
          id: '1',
          content: 'Hi! How can I help you?',
          role: 'assistant',
          timestamp: new Date(),
        },
        {
          id: '2',
          content: 'Hello',
          role: 'user',
          timestamp: new Date(),
        },
      ],
    },
  ],
  pathwayId: '',
  widgetId: '',

  // Web widget
  voice: 'June',
}
